import React from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Timer, Swords } from "lucide-react";
import PageLayout from "../components/PageLayout";
import MenuButton from "../components/MenuButton";
import { useLang } from "../context/LangContext";

const GamesPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  const items = [
    {
      icon: Zap,
      title: t("marathon"),
      subtitle: t("marathonSub"),
      path: "/quiz/marafon",
    },
    {
      icon: Timer,
      title: "Time Attack",
      subtitle: t("timeAttackSub"),
      path: "/time-attack",
    },
    {
      icon: Swords,
      title: "Duel",
      subtitle: t("duelSub"),
      path: "/duel",
      badge: t("badgeNew"),
    },
  ];

  return (
    <PageLayout title={t("catGames")} subtitle={t("gamesSubtitle")}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((item) => (
          <MenuButton
            key={item.path}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
            badge={item.badge}
            onClick={() => navigate(item.path)}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default GamesPage;
